import browser from 'browser-detect'

const DEBUG_ENABLE = false

export default {
  data () {
    return {
      windowWidth: 0,
      windowHeight: 0,
      headerHeight: 100,
      headerOffsetLeft: 0,
      headerOffsetRight: 0
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeListener)
  },
  mounted () {
    this.initEventListeners()
    this.$nextTick().then(() => {
      this.resizeListener()
    })
  },
  computed: {
    // хром скрытую таблицу переодически делает
    // чуть меньше, поэтому чуть чуть ее увеличиваем
    magicChromePixel () {
      if (this.isChrome) {
        return 0.2
      } else {
        return 0
      }
    },
    browser () {
      return browser()
    },
    // https://github.com/KennethanCeyer/browser-detect/blob/master/src/definitions.ts
    isChrome () {
      return this.browser.name === 'chrome' || this.browser.name === 'yandexbrowser'
    },
    fixedTableRightHeight () {
      if (this.tableHeightRight) {
        return this.tableHeightRight
      }
      return this.calcTableHeight
    },
    fewRows () {
      if (!this.data) {
        return true
      } else if (this.data && this.data.data && this.data.data.length <= this.fewRowsCount) {
        return true
      }
      return false
    },
    calcTableHeight () {
      if (this.calculateTableHeight === false) {
        return 0
      }
      let bodyHeight = this.windowHeight
      let foreignElementsHeight = 0
      let headerHeight = this.headerHeight
      let toolbarHeight = 80
      let footerHeight = 76
      let bottomOffset = 5
      let debug = false
      if (!this.foreignElementsHeight) {
        let nodes = document.querySelectorAll(this.headerSelector)
        debug && console.log(this.headerSelector, nodes)
        if (nodes && nodes.length > 0) {
          foreignElementsHeight += +nodes[0].offsetHeight
        }

        nodes = document.querySelectorAll(this.toolbarSelector)
        debug && console.log(this.toolbarSelector, nodes)
        if (nodes && nodes.length > 0) {
          foreignElementsHeight += +(nodes[0].offsetHeight || toolbarHeight)
        }

        nodes = document.querySelectorAll(this.footerSelector)
        debug && console.log(this.footerSelector, nodes)
        if (nodes && nodes.length > 0) {
          foreignElementsHeight += +(nodes[0].offsetHeight || footerHeight)
        }

        // .body.body-table padding-bottom size(50px) + border(??)
        // if disable padding-bottom we dont need in bottomOffset
        bottomOffset = 57
      } else {
        foreignElementsHeight = this.foreignElementsHeight
      }
      // added height of pagination block
      if (this.enablePagination && !this.tableInOfflineMode) {
        let paginationHeight = 62
        let paginationBottomOffset = 27
        if (this.meta && this.$refs.pagination) {
          paginationHeight = this.$refs.pagination.offsetHeight
        }
        paginationHeight = paginationHeight + paginationBottomOffset
        foreignElementsHeight = foreignElementsHeight + paginationHeight
      }
      debug && console.log('TE header=' + headerHeight + ' foreignElementsHeight' + foreignElementsHeight)

      return bodyHeight - bottomOffset - foreignElementsHeight - headerHeight - this.tableBottomScrollHeight
    },
    fixedTableHeight () {
      if (this.tableHeight) {
        return this.tableHeight
      }
      let h = this.calcTableHeight
      if (h) {
        h = +h + (+this.tableBottomScrollHeight)
      }
      return h
    },
    bodyWrapperOverflow () {
      return 'scroll'
    },
    fieldsCols () {
      let fields = this.attributes
      let colsWidthSum = 0
      for (let name in fields) {
        if (!fields[name].hasOwnProperty('width')) {
          fields[name].width = this.defaultColumnWidth
          colsWidthSum = +colsWidthSum + (+this.defaultColumnWidth)
        } else {
          colsWidthSum = +colsWidthSum + (+fields[name].width)
        }
      }
      // resize cols if table width 100% and cols rows < 100%
      let bodyWidth = this.windowWidth

      // if (this.showActionButtons) {
      bodyWidth = bodyWidth - (+this.actionColumnWidth)
      // }

      // left and right offset
      let offset = this.headerOffsetLeft + this.headerOffsetRight
      bodyWidth = Math.ceil(bodyWidth - offset)

      let widthResizeQ = 1
      if (bodyWidth > colsWidthSum) {
        widthResizeQ = bodyWidth / colsWidthSum
      }

      let divisionFieldName = null
      let colWSum = 0
      for (let name in fields) {
        fields[name].resizedWidth = Math.ceil(fields[name].width * widthResizeQ)
        colWSum = colWSum + fields[name].resizedWidth
        divisionFieldName = divisionFieldName || name
      }

      if (widthResizeQ > 1 && fields[divisionFieldName]) {
        // в ff колонки в таблице чуть меньше
        const magicFFPixel = this.isChrome ? 1 : 2
        const division = colWSum - bodyWidth
        DEBUG_ENABLE && console.log(+fields[divisionFieldName].resizedWidth)
        fields[divisionFieldName].resizedWidth = fields[divisionFieldName].resizedWidth - division - magicFFPixel
        DEBUG_ENABLE && console.log('widthResizeQ', widthResizeQ, division, +fields[divisionFieldName].resizedWidth)
      }
      return fields
    },
    tableWidth () {
      let fieldsCols = this.fieldsCols
      let width = 0
      for (let fieldName in fieldsCols) {
        // dont summary fixed columns
        if (this.fixedColumns.indexOf(fieldName) === -1) {
          width = width + (+fieldsCols[fieldName].resizedWidth)
        } else {
          console.log('fixedColumns method doesnt support')
        }
      }
      // dont summary fixed columns
      /*
      if (this.showActionButtons) {
        width = width + (+this.actionColumnWidth)
      }
      */
      return width
    },
    emptyRowHeight () {
      return '100%'
    }
  },
  methods: {
    resizeListener (e) {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
      if (this.$refs.tableHeader && this.$refs.tableHeader.getBoundingClientRect() && this.$refs.tableHeader.getBoundingClientRect().height) {
        let rect = this.$refs.tableHeader.getBoundingClientRect()
        let wrapperRect = this.$refs.tableHeaderWrapper.getBoundingClientRect()
        this.headerHeight = +rect.height
        this.headerOffsetLeft = +wrapperRect.left
        this.headerOffsetRight = this.windowWidth - wrapperRect.right
      } else {
        setTimeout(() => {
          this.resizeListener()
        }, 100)
      }
    },
    initEventListeners () {
      window.addEventListener('resize', this.resizeListener)
      this.resizeListener()
    },
    /**
     * scroll main table
     * @param $event
     */
    scrollLeftHandler ($event) {
      let el = $event.srcElement || $event.target
      this.scrollLeft = el.scrollLeft
      if (this.$refs.tableFixedPS) {
        this.$refs.tableFixedPS.setScrollTop(el.scrollTop)
      } else if (this.$refs.tableFixed) {
        this.$refs.tableFixed.scrollTop = el.scrollTop
      }
    },
    /**
     * scroll action column
     * @param $event
     */
    scrollTopHandler ($event) {
      let el = $event.srcElement || $event.target
      if (this.$refs.tablePS) {
        // console.log(this.$refs.tablePS)
        this.$refs.tablePS.setScrollTop(el.scrollTop)
      } else if (this.$refs.table) {
        this.$refs.table.scrollTop = el.scrollTop
      }
    }
  }
}
